import { ValidationError } from '../types/types';

export function formatValidationError(error: ValidationError): string {
    const title = error.title ?? 'Validation error';

    if (!error.errors || Object.keys(error.errors).length === 0) return title;

    const formatted = error.useErrorsGroupNamesAsMessages
        ? Object.entries(error.errors)
            .map(([group, messages]) => {
                const formattedMessages = messages.map(msg => `  - ${msg}`).join('\n');
                return `${group}:\n${formattedMessages}`;
            })
            .join('\n\n')
        : Object.values(error.errors)
            .flat()
            .map(msg => `- ${msg}`)
            .join('\n');

    return `${title}\n\n${formatted}`;
}
